/** @format */
/** @format */

import React, { useState } from "react";
import Modal from "react-awesome-modal";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// Table
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

const PaymentListTable = () => {
  // Date
  const [selectedDate, setSelectedDate] = useState(new Date("2014-08-18T21:11:54"));
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Select
  const [category, setAge] = useState("");
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  //모달
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => {
    setModalVisible(false);
  };
  const handleModalOkButton = () => {
    setModalVisible(false);
  };

  return (
    <div className="border-table">
      <ToolkitProvider keyField="id" bootstrap4 data={products} columns={columns} search>
        {(props) => (
          <div className="px-3">
            {/* Search Area */}
            <div className="row flex items-center justify-between">
              <div className="col-12 col-md-6 col-xl-2 mt-3 mt-md-0">
                <FormControl className="w-full">
                  <Select value={category} onChange={handleChange} displayEmpty>
                    <MenuItem value="" disabled>
                      <span className="text-888">현황</span>
                    </MenuItem>
                    <MenuItem value={1}>
                      <i className="mdi mdi-check mr-4 text-888 text-base"></i>
                      <p className="mb-0 text-555">환불 완료</p>
                    </MenuItem>
                    <MenuItem value={2}>
                      <i className="mdi mdi-check mr-4 text-888 text-base"></i>
                      <p className="mb-0 text-555">환불 중</p>
                    </MenuItem>
                    <MenuItem value={3}>
                      <i className="mdi mdi-check mr-4 text-888 text-base"></i>
                      <p className="mb-0 text-555">환불 접수</p>
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="col-12 col-md-6 col-xl-5 search-area flex align-items-center justify-center mt-3 mt-md-0">
                <i className="ti-search pl-3"></i>
                <SearchBar {...props.searchProps} className="border-search-box" />
                <ClearSearchButton {...props.searchProps} className="clear-btn-2 mr-3" />
              </div>
              <div className="col-12 col-xl-5 mt-3 mt-xl-0">
                <div className="block text-center sm:flex w-full justify-between items-center">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} className="w-full">
                    <KeyboardDatePicker
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      value={selectedDate}
                      onChange={handleDateChange}
                      className="w-full"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                  <span className="px-2 font-bold text-555">~</span>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      value={selectedDate}
                      onChange={handleDateChange}
                      className="w-full"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
            {/* Table Area */}
            <div className="block sm:flex justify-between items-center mt-3">
              <h5 className="mb-3">
                환불 내역 <span className="font-bold text-333 text-danger ml-2">100</span>
              </h5>
            </div>

            {/* 모달 */}
            <Modal visible={modalVisible} width="400" height="220" effect="fadeInUp" onClickAway={() => closeModal()}>
              <div className="aiso-modal">
                <div className="aiso-modal-header">
                  <button className="btn btn-text-grayPrimary p-3" onClick={() => setModalVisible(false)}>
                    <i className="ti-close font-bold"></i>
                  </button>
                </div>
                <div className="aiso-modal-body text-center">
                  <h3 className="text-xl font-bold text-danger mb-0" id="modal-title">
                    삭제 하시겠습니까?
                  </h3>
                  <div className="mt-2">
                    <p className="text-xs text-gray-500">삭제한 데이터는 복구가 불가능합니다.</p>
                  </div>
                </div>
                <div className="aiso-modal-footer text-center">
                  <button type="button" className="btn btn-modal-x w-1/3" onClick={() => handleModalOkButton()}>
                    확인
                  </button>
                </div>
              </div>
            </Modal>
            <div>
              <PaginationProvider pagination={paginationFactory(options)}>
                {({ paginationProps, paginationTableProps }) => (
                  <div>
                    <BootstrapTable
                      keyField="id"
                      data={products}
                      columns={columns}
                      noDataIndication=" "
                      defaultSorted={defaultSorted}
                      {...paginationTableProps}
                      {...props.baseProps}
                      wrapperClasses="table-responsive"
                      classes="mytable-hover2 border-table"
                      rowClasses="mytable-hover-row2"
                    />
                    <div className="flex justify-between items-center w-full">
                      <PaginationListStandalone {...paginationProps} />
                      <div className="flex justify-end">
                        <PaginationTotalStandalone {...paginationProps} />
                      </div>
                    </div>
                  </div>
                )}
              </PaginationProvider>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

// 데이터 리스트
const { SearchBar, ClearSearchButton } = Search;

var products = [
  {
    id: "01",
    현황: "",
    충전크레딧: "",
    충전금액: "",
    환불크레딧: "",
    환불금액: "",
    충전일: "",
    환불일: "",
  },
  {
    id: "02",
    현황: "",
    충전크레딧: "",
    충전금액: "",
    환불크레딧: "",
    환불금액: "",
    충전일: "",
    환불일: "",
  },
];

const columns = [
  {
    dataField: "id",
    text: "No",
    sort: true,
    align: "center",
    headerAlign: "center",
    style: {
      fontSize: "13px",
      color: "#aaa",
      fontWeight: "bold",
    },
  },
  {
    dataField: "현황",
    text: "현황",
    align: "center",
    headerAlign: "center",
    formatter: () => {
      return (
        <div>
          <p className="text-xs text-primary font-bold">환불중</p>
          <p className="badge badge-pill badge-primary font-bold">환불 완료</p>
          <p className="badge badge-pill badge-danger font-bold">환불 취소</p>
          <p className="text-xs text-888 font-bold">환불 접수</p>
        </div>
      );
    },
    style: {
      minWidth: "40px",
      width: "40px",
    },
  },
  {
    dataField: "충전크레딧",
    text: "충전 크레딧 (Credit)",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div>
          <p className="mb-0 font-bold text-333 cell-nowrap">20,000</p>
          <p className="mb-0 text-ss text-555">Credit</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
  {
    dataField: "충전금액",
    text: "충전 금액 (원)",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div>
          <p className="mb-0 font-bold text-333 cell-nowrap">20,000</p>
          <p className="mb-0 text-ss text-555">원</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
  {
    dataField: "환불크레딧",
    text: "환불 크레딧 (Credit)",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div>
          <p className="mb-0 font-bold text-danger cell-nowrap">20,000</p>
          <p className="mb-0 text-ss text-555">Credit</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
  {
    dataField: "환불금액",
    text: "환불 금액 (원)",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div>
          <p className="mb-0 font-bold text-danger cell-nowrap">20,000</p>
          <p className="mb-0 text-ss text-555">원</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
  {
    dataField: "충전일",
    text: "충전일",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div className="m-0">
          <p className="text-xs font-bold text-888">2021-00-00</p>
          <p className="mb-0 text-xs text-888">00:00:00</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
  {
    dataField: "환불일",
    text: "환불일",
    sort: true,
    align: "right",
    headerAlign: "center",
    formatter: () => {
      return (
        <div className="m-0">
          <p className="text-xs font-bold text-555">2021-00-00</p>
          <p className="mb-0 text-xs text-555">00:00:00</p>
        </div>
      );
    },
    style: {
      minWidth: "110px",
    },
  },
];

const defaultSorted = [
  {
    dataField: "id",
    order: "desc",
  },
];
const options = {
  custom: true,
  totalSize: products.length,
};

export default PaymentListTable;
